import queryString from 'query-string';
import 'whatwg-fetch';

const BASE_URL = '/admin/api/';

class Api {
  //public authToken = '';

  getHeaders (headers) {
    return Object.assign({}, {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      //'Authorization': `Bearer: ${this.authToken}`,
    }, headers);
  }

  handleResponse = (response) => {
    if (response.ok) return response.json();
    return response.json().then((error) => {
      error.code = response.status;
      throw error;
    });
  }

  get = (path, params = {}, headers = {}) => (
    fetch(`${BASE_URL}${path}?${queryString.stringify(params, {arrayFormat: 'bracket'})}`, {
      headers: this.getHeaders(headers),
    }).then((r) => this.handleResponse(r))
  )
  post =  (path, params = {}, headers = {})  => (
    fetch(`${BASE_URL}${path}`, {
      headers:  this.getHeaders(headers),
      method: 'POST',
      body: JSON.stringify(params),
    }).then((r) => this.handleResponse(r))
  )

  delete =  (path, params = {}, headers = {})  => (
    fetch(`${BASE_URL}${path}`, {
      headers:  this.getHeaders(headers),
      method: 'DELETE',
      body: JSON.stringify(params),
    }).then((r) => this.handleResponse(r))
  )

  getDashboard = () => this.get('v1/dashboard')

  getDashboardSettings = () => this.get('v1/dashboard/settings')

  saveDashboardSettings = (settings) => this.post('v1/dashboard/settings', { settings })

  getActivities = (beforeId) => this.get('v1/dashboard/activities_feed', { before_id: beforeId })

}

export default new Api();
